/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Button } from '@mui/material';

import { OverlayFormWithControls } from '../../../components/OverlayFormWithControls/OverlayFormWithControls';
import { Namespaces } from '../../../i18n';
import { CommonCreateForm } from './CommonCreateForm';
import { TCommonCreateContainer, TState } from './types';

export const CommonCreateContainer = memo<TCommonCreateContainer>(
  ({ errorMessage, isFetchingOrganizations, ...rest }) => {
    const [pickedState, setPickedState] = useState<TState>({});
    const { t } = useTranslation(Namespaces.OrganizationAdmin);

    const isButtonDisabled = !rest.formProps.values.organization || isFetchingOrganizations;

    return (
      <OverlayFormWithControls
        onSubmit={rest.formProps.handleSubmit}
        disableFormGrow
        buttons={
          <Button type="submit" variant="contained" disabled={isButtonDisabled} data-cy="create-form-submit-button">
            {t(`departments.action_add.form_action_create`)}
          </Button>
        }
      >
        <CommonCreateForm
          {...rest}
          isFetchingOrganizations={isFetchingOrganizations}
          pickedState={pickedState}
          setPickedState={setPickedState}
        />
        {!!errorMessage && <Alert severity="error">{t(`departments.action_add.error_${errorMessage}`)}</Alert>}
      </OverlayFormWithControls>
    );
  },
);
